const ArrowUpRight = ({ className = ''}) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none" className={className}>
        <g clipPath="url(#clip0_4_71)">
            <path d="M52.5 0H23.3333V2.33333H52.017L0.0139771 54.3363L1.66364 55.986L53.6666 3.983V32.6667H56V3.5C56 1.57033 54.4296 0 52.5 0Z" fill="currentColor"/>
        </g>
        <defs>
            <clipPath id="clip0_4_71">
                <rect width="56" height="56" fill="white"/>
            </clipPath>
        </defs>
    </svg>
)

export default ArrowUpRight
